<template>
	<!-- 雇主险管理 -->
	<div>
		<div v-show="Gzxgl">
			<div style="
          font-size: 20px;
          float: left;
          margin: -40px 0 0 40px;
          font-weight: 600;
        ">
				雇主险管理
			</div>
			<!-- 主体 -->
			<div style="height: 750px; background-color: white; margin: 75px 40px 0 40px ">
				<!-- 查询框 -->
				<div style="margin-left: 3%">
					<div style="height: 40px"></div>
					<div style="display: inline-block">
						<span>保单名称 </span>
						<el-input v-model="condition.insurance_name" style="margin-left: 10px; width: 150px"
							placeholder="请输入保单名称"></el-input>
					</div>

					<div style="display: inline-block; margin-left: 10px">
						<span>承保公司 </span>
						<el-select v-model="condition.company_id" style="margin-left: 10px; width: 150px"
							placeholder="请选择承保公司" clearable>
							<el-option v-for="item in cbgsList" :key="item.id" :label="item.company_name"
								:value="item.id">
							</el-option>
						</el-select>
					</div>

					<div style="display: inline-block; margin-left: 10px">
						<span>生效日期 </span>
						<el-date-picker style="width: 150px; margin-left: 10px" v-model="condition.create_time"
							type="date" placeholder="请选择">
						</el-date-picker>
					</div>

					<div style="display: inline-block; margin-left: 10px">
						<span>保单号 </span>
						<el-input v-model="condition.policy_no" style="margin-left: 10px; width: 150px"
							placeholder="请输入保单号"></el-input>
					</div>

					<!-- 按钮 -->
					<div style="display: inline-block; margin-left: 50px">
						<el-button type="goon" @click="Find">查询</el-button>
						<el-button type="goon" @click="Dell()">删除</el-button>
						<el-button type="addbtn" @click="add()">新增</el-button>
						<el-button type="addbtn" @click="pipeis()">匹配</el-button>
					</div>
					<div style="display:inline-block; float:right; margin-right:50px ">
						<download-excel class="export-excel-wrapper" :fields="download_excel" title="缴纳人员清单"
									name="保单人员明细.xls" :fetch="ExportForm"
									style="top:100px">
							<el-button type="goon" >导表</el-button>
						</download-excel>
            		</div>
				</div>

				<!-- 表格 -->
				<div style="margin: 3% 3% 0 3%">
					<el-table :header-cell-style="{ background: '#F0F0F0', color: '#000000' }"
						:row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" tooltip-effect="dark"
						style="width: 100%;" height="540" @selection-change="handleSelectionChange">
						<el-table-column type="selection" width="55"> </el-table-column>
						<el-table-column align="center" label="序号" width="50">
							<template slot-scope="scope_1">{{ scope_1.$index + 1 }}</template>
						</el-table-column>
						<el-table-column prop="insurance_name" align="center" label="保单名称" width="220"></el-table-column>
						<el-table-column prop="" align="center" label="投保内容" width="80">雇主险</el-table-column>
						<el-table-column prop="insure_account" align="center" label="投保账户" width="120"></el-table-column>
						<el-table-column prop="company_name" align="center" label="承保公司" width="120"></el-table-column>
						<el-table-column prop="" align="center" label="生效起止时间" width="110">
							<template slot-scope="scope">
								{{ scope.row.start_date }} ~ {{ scope.row.end_date }}
							</template>
						</el-table-column>
						<el-table-column prop="policy_no" align="center" label="保单号" width="130"></el-table-column>
						<el-table-column prop="insure_number" align="center" label="投保人数"></el-table-column>
						<el-table-column prop="unit_price" align="center" label="单价"></el-table-column>
						<el-table-column prop="premium" align="center" label="保费"></el-table-column>
						<el-table-column prop="insured_amount" align="center" label="保额"></el-table-column>
						<el-table-column align="center" label="操作" width="200" fixed="right">
							<template slot-scope="scope">
								<img src="../../../assets/编辑.png" @click="modify(scope.row)" />
								<img src="../../../assets/详情.png" @click="xiangqing(scope.row)" />
								<img src="../../../assets/明细.png" @click="mingxi(scope.row.id)" />
								<img src="../../../assets/匹配.png" @click="pipei()" />
							</template>
						</el-table-column>
					</el-table>

					<!-- 分页 -->
					<el-row style="margin-top: 10px; text-align: center">
						<el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
							layout=" prev, pager, next, jumper" :total="total">
						</el-pagination>
					</el-row>
				</div>
			</div>
		</div>
		<!-- 匹配 -->
		<el-dialog title="匹配" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false" :center="true"
			:before-close="handleClose">
			<pipei ref="pipeis" v-show="showpi"></pipei>
		</el-dialog>

		<add ref="adds" v-show="showadd"></add>
		<modify ref="modifys" v-show="showmodify" :ruleForm="ruleForm"></modify>
		<edit ref="edits" v-show="showedit" :ruleForm="ruleForm"></edit>
		<detailed ref="detaileds" v-show="showdetailed" :employer_id="ruleForm.id"></detailed>
	</div>
</template>

<script>
	import axios from "axios";
	import add from "./Gzxgl_add.vue";
	import edit from "./Gzxgl_edit.vue";
	import detailed from "./Gzxgl_detailed.vue";
	import pipei from "./Gzxgl_pipei.vue";
	import modify from "./Gzxgl_modify.vue";

	export default {
		components: {
			add: add,
			edit: edit,
			detailed: detailed,
			pipei: pipei,
			modify: modify,
		},
		data() {
			return {
				page_num: 1,
				page_size: 10,
				total: 0,
				tableData: [],
				cbgsList: [],
				//删除ids
				ids: [],

				ruleForm: {
					id: '',
					insurance_name: '',
					insure_account: '',
					company_id: '',
					start_date: '',
					end_date: '',
					policy_no: '',
					insure_number: '',
					unit_price: '',
					premium: '',
					insured_amount: '',
					proportion: '',
					company_contacts: '',
					company_telephone: '',
					remarks: '',
					spare1: '',
					spare2: '',
					insurance_url: '',
					enclosure_url: '',
					rangeList: [],
					rangeLists: [],
				},

				download_excel: {
					"保单名称":"insurance_name",
					"投保账户":"insure_account",
					"承保公司":"company_name",
					"有效期开始时间":"start_date",
					"有效期截至时间":"end_date",
					"保单号":"policy_no",
					"组织架构": "range",
					"姓名": "staff_name",
					"职位": "post_name",
					"身份证号": {
						field: "staff_card",
						callback: value => {
							return "&nbsp;" + value;
						}
					},
					"手机号": "staff_telephone",
					"员工状态": "is_staff_status",
					"缴纳状态": "is_payment_status",
					"缴纳时间": "payment_date",
					"退保时间": "staff_date",
					"导表时间": "export_form_date",
				},

				condition: {
					id: "id",
					insurance_name: "",
					company_id: "",
					policy_no: "",
					create_time: "",
				},
				// 权限
				Gzxgl: true,
				showadd: false,
				showedit: false,
				showmodify: false,
				showdetailed: false,
				showpi: false,
				dialogVisible: false,
				
				rangeListIndex: 0,
			};
		},
		methods: {
			// 全选
			handleSelectionChange(e) {
				this.ids = [];
				e.forEach((item) => {
					this.ids.push(item.id);
					// this.ids.push({
					//   id:item.id,
					//   company_id:item.company_id
					// });
				});
			},
			// 新增
			add() {
				this.Gzxgl = false;
				this.showadd = true;
				this.$refs.adds.add;
				this.Find();
				this.trash();
			},
			// 修改
			modify(e) {
				this.Gzxgl = false;
				this.showmodify = true;
				this.ruleForm.id = e.id;
				this.ruleForm.insurance_name = e.insurance_name;
				this.ruleForm.insure_account = e.insure_account;
				this.ruleForm.company_id = e.company_id;
				this.ruleForm.dictionaries_id = e.dictionaries_id;
				this.ruleForm.company_name = e.company_name;
				this.ruleForm.start_date = e.start_date;
				this.ruleForm.end_date = e.end_date;
				this.ruleForm.policy_no = e.policy_no;
				this.ruleForm.insure_number = e.insure_number;
				this.ruleForm.unit_price = e.unit_price;
				this.ruleForm.premium = e.premium;
				this.ruleForm.insured_amount = e.insured_amount;
				this.ruleForm.proportion = e.proportion;
				this.ruleForm.remarks = e.remarks;
				this.ruleForm.company_contacts = e.company_contacts;
				this.ruleForm.company_telephone = e.company_telephone;
				this.ruleForm.insurance_url = e.insurance_url;
				this.ruleForm.enclosure_url = e.enclosure_url;
				this.ruleForm.rangeList = e.rangeList;
			},
			// 返回
			Return() {
				this.showadd = false;
				this.showedit = false;
				this.showdetailed = false;
				this.showmodify = false;
				this.Gzxgl = true;
				this.Find();
				this.trash();
			},

			//导表
			async ExportForm(){
				var url = 'EmployerDetailed/selectAllPayments';
				var record = {};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						if(data.length > 0){
							this.$message.success("导表成功！文件下载中！");
							return data;
						}else{
                            this.$message.success("没有可以导出的数据！");
                            return null;
                        }
					}
				}
			},

			//查询
			async Find() {
				var url = "Employer/selectAll";
				var record = {
					page_num: this.page_num,
					page_size: this.page_size,
					insurance_name: this.condition.insurance_name,
					company_id: this.condition.company_id,
					policy_no: this.condition.policy_no,
					create_time: this.condition.create_time,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === "-2000") {
					this.$message.error("服务器未响应！请稍后重试");
				} else {
					var code = data.code;
					var data = data.data;
					if (code === "200") {
						this.tableData = data.list;
						this.total = data.total;
					} else {
						this.$message.warning("请求失败！请稍后重试");
					}
				}
			},
			//删除
			Dell(e) {
				var ids;
				if (e === null || e === "" || e === undefined) {
					if (this.ids === null || this.ids.length <= 0) {
						this.$message.warning("请先选择操作数据！");
						return false;
					}
					ids = this.ids;
				} else {
					ids = [e];
				}
				const url = this.$globals.http + "Employer/del";
				axios
					.post(url, {
						ids: ids,
					})
					.then((response) => {
						var code = response.data.code;
						var data = response.data.data;

						if (code == "200") {
							this.$message.success(data);
							this.Find();
						} else {
							this.$message.warning("请求失败！请稍后重试");
						}
					})
					.catch((error) => {
						console.log(error);
						this.$message.error("服务器未响应！请稍后重试");
					});
			},

			//匹配
			pipeis(e) {
				var ids;
				if (e === null || e === "" || e === undefined) {
					if (this.ids === null || this.ids.length <= 0) {
						this.$message.warning("请先选择操作数据！");
						return false;
					}
					ids = this.ids;
				} else {
					ids = [e];
				}
				const url = this.$globals.http + "StaffInduction/selectPps";
				axios
				.post(url, {
						ids: ids,
					})
					.then((response) => {
						var code = response.data.code;
						var data = response.data.data;

						if (code == "200") {
							this.$message.success(data);
							this.$message.warning("请求成功！");
							this.Find();
						} else {
							this.$message.warning("请求失败！请稍后重试");
						}
					})
					.catch((error) => {
						this.$message.error("服务器未响应！请稍后重试");
					});
			},

			// 操作详情
			xiangqing(e) {
				this.Gzxgl = false;
				this.showedit = true;
				this.ruleForm.insurance_name = e.insurance_name;
				this.ruleForm.insure_account = e.insure_account;
				this.ruleForm.company_id = e.company_id;
				this.ruleForm.dictionaries_id = e.dictionaries_id;
				this.ruleForm.company_name = e.company_name;
				this.ruleForm.id = e.id;
				this.ruleForm.start_date = e.start_date;
				this.ruleForm.end_date = e.end_date;
				this.ruleForm.policy_no = e.policy_no;
				this.ruleForm.insure_number = e.insure_number;
				this.ruleForm.unit_price = e.unit_price;
				this.ruleForm.premium = e.premium;
				this.ruleForm.insured_amount = e.insured_amount;
				this.ruleForm.proportion = e.proportion;
				this.ruleForm.remarks = e.remarks;
				this.ruleForm.company_contacts = e.company_contacts;
				this.ruleForm.company_telephone = e.company_telephone;
				this.ruleForm.insurance_url = e.insurance_url;
				this.ruleForm.enclosure_url = e.enclosure_url;
				this.ruleForm.rangeList = e.rangeList;
			},
			// 操作明细
			mingxi(e) {
				this.Gzxgl = false;
				this.showdetailed = true;
				this.$refs["detaileds"].condition.employer_id = e;
				this.$refs["detaileds"].Find();
			},
			// 操作匹配
			pipei() {
				this.dialogVisible = true;
				this.showpi = true;
				this.$refs.pipeis.pipei;
			},
			// 弹窗
			handleClose() {
				this.dialogVisible = false;
			},
			//分页
			handleCurrentChange(val) {
				this.page_num = val;
				this.Find();
			},
			//清除数据
			trash() {
				this.ruleForm.id = "";
				this.ruleForm.insurance_name = "";
				this.ruleForm.insure_account = "";
				this.ruleForm.company_id = "";
				this.ruleForm.company_name = "";
				this.ruleForm.start_date = "";
				this.ruleForm.end_date = "";
				this.ruleForm.policy_no = "";
				this.ruleForm.insure_number = "";
				this.ruleForm.unit_price = "";
				this.ruleForm.premium = "";
				this.ruleForm.proportion = "";
				this.ruleForm.company_contacts = "";
				this.ruleForm.company_telephone = "";
				this.ruleForm.remarks = "";
				this.ruleForm.spare1 = "";
				this.ruleForm.spare2 = "";
			},
		},
		async created() {
			this.Find();
			// 承保公司
			var cbgsList = await this.$globals.AxiosPost("company/SelectAll", {});
			this.cbgsList = cbgsList.data;
		},
	};
</script>

<style>
	.el-button--goon:focus,
	.el-button--goon:hover {
		background: #006e4b;
		border-color: #05573d;
		color: #fff;
	}

	.el-button--addbtn:focus,
	.el-button--addbtn:hover {
		background: #fff;
		border-color: #05573d;
		color: #006e4b;
	}

	.el-button--goon {
		color: #fff;
		background-color: #006e4b;
		border-color: #006e4b;
		font-size: 15px;
		width: 85px;
	}

	.el-button--addbtn {
		color: #006e4b;
		background-color: #fff;
		border-color: #006e4b;
		font-size: 15px;
		width: 85px;
	}

	.el-table .warning-row {
		background: oldlace;
	}

	.el-table .success-row {
		background: #f0f9eb;
	}

	.el-checkbox__input.is-checked .el-checkbox__inner {
		background-color: #006e4b;
		border-color: #006e4b;
	}

	.el-checkbox__input.is-focus .el-checkbox__inner {
		border-color: #006e4b;
	}

	.el-checkbox__inner:hover {
		border-color: #006e4b;
	}

	.el-select-dropdown .el-popper {
		min-width: 410px;
	}
</style>



// WEBPACK FOOTER //
// Gzxgl.vue?75fb72cf